/**
 * Pomoćne funkcije za serijalizaciju log zapisa (DBLogger, NativeLogger, SendLogService).
 *
 * Glavni razlog postojanja: Error NIJE JSON-serijalizabilan — JSON.stringify(new Error())
 * vraća "{}", pa su iz logova poslatih na server nestajali i poruka i stack trace greške.
 */

/** JSON.stringify replacer koji Error pretvara u {name, message, stack}. */
export function errorReplacer(key: any, value: any) {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack,
    };
  }
  return value;
}

/** JSON.stringify koji ne sme da pukne (ciklične strukture, DOM čvorovi...) — fallback String(value). */
export function safeStringify(value: any): string {
  try {
    return JSON.stringify(value, errorReplacer);
  } catch {
    return String(value);
  }
}

/**
 * `additional` argumenti logger poziva → JSON-bezbedne kopije za upis u IndexedDB.
 * Vrednost koja ne može da se serijalizuje postaje String(vrednost), da jedan
 * egzotičan argument (DOM čvor, ciklična struktura) ne bi oborio ceo zapis
 * (DataCloneError u Dexie add).
 */
export function toPlainAdditional(additional: any[] | undefined): any[] | undefined {
  if (!additional?.length) {
    return undefined;
  }

  return additional.map(item => {
    try {
      return JSON.parse(JSON.stringify(item, errorReplacer));
    } catch {
      return String(item);
    }
  });
}
